import { isFunction } from 'underscore';
import { useRef } from 'react';

/**
 * Like useRef, but the argument must be a function that returns the initial value.
 * @param {function} initializer a function that returns the initial value
 * @returns {object} a ref object
 */
export const useRefInit = (initializer) => {
  const isInitialized = useRef(false);
  const ref = useRef();
  if (!isInitialized.current) {
    if (isFunction(initializer)) {
      ref.current = initializer();
    } else {
      throw new Error('`initializer` must be a function');
    }
    isInitialized.current = true;
  }
  return ref;
};
